import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=604b0298&scoped=true&"
import script from "./NavItem.vue?vue&type=script&lang=ts&"
export * from "./NavItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=604b0298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b0298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
